$ ->
  $('.email-info').tooltip()

  $(document).on 'click', '.downloadCSV a', (e) ->
    if $(@).hasClass('csv-email')
      $(@).replaceWith("<span>Your Student Activity CSV is generating. Please check your email.</span>")
    else
      $(@).replaceWith("<span>Your Student Activity CSV is downloading.</span>")
